
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class RateFixingItemsDialog extends _Ext.ItemEditorDialog<RateFixingItemsRow> {
        protected getFormKey() { return RateFixingItemsForm.formKey; }
        //protected getIdProperty() { return RateFixingItemsRow.idProperty; }
        protected getLocalTextPrefix() { return RateFixingItemsRow.localTextPrefix; }
        // protected getNameProperty() { return RateFixingItemsRow.nameProperty; }
        //protected getService() { return RateFixingItemsService.baseUrl; }
        protected getDeletePermission() { return RateFixingItemsRow.deletePermission; }
        protected getInsertPermission() { return RateFixingItemsRow.insertPermission; }
        protected getUpdatePermission() { return RateFixingItemsRow.updatePermission; }

        protected form = new RateFixingItemsForm(this.idPrefix);

        // #region Public Variables
        public masterId: number;
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean;
        // #endregion 

        constructor() {
            super();

            //Make grid full width
            //q.hideEditorLabel(this.form.BOMDetails);
            //q.hideEditorLabel(this.form.ImageName);
            //q.hideEditorLabel(this.form.LaborDetails);

            // **** Assign Values to BOM and Labor Editor ****
            // this will be used to calculate Rate for RM and Labor while adding new item.
            //this.form.BOMDetails.RateListId = this.RateListId;
            //this.form.LaborDetails.LaborListId = this.LaborListId;
            //this.form.LaborDetails.LaborMarkup = this.LaborMarkup;


            // **** On Pieces Change Event **** 
            this.form.Pieces.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());                
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
            });

            // **** On NetAmount Change Event **** 
            this.form.NetAmount.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
            });

            // **** On Product Change Event **** 
            this.form.ProductId.changeSelect2(e => {
                if (this.form.ProductId.value.toString() != null || this.form.ProductId.value.toString() != "0") {

                    var prdid = this.form.ProductId.value;

                    let prddetails;
                    OMS.ProductMasterService.Retrieve({
                        EntityId: parseInt(prdid)
                    }, response => {
                        prddetails = response.Entity
                    }, { async: false });
                    var atb = prddetails.AttributeId;
                    var x = prddetails.ProductName;
                    this.form.ProductCode.value = prddetails.ProductCode;
                    this.form.ProductName.value = prddetails.ProductName;
                    this.form.AttributeId.value = atb.toString();
                    this.form.Weight.value = prddetails.Weight;
                    this.form.Pieces.value = prddetails.Pieces;
                    this.form.OtherPieces.value = prddetails.OtherPieces;
                    this.form.OtherWeight.value = prddetails.OtherWeight;
                    this.form.NetWeight.value = prddetails.NetWeight;
                    this.form.StonePieces.value = prddetails.StonePieces;
                    this.form.StoneWeight.value = prddetails.StoneWeight;
                    this.form.DiamondWeight.value = prddetails.DiamondWeight;
                    this.form.DiamondPieces.value = prddetails.DiamondPieces;
                    
                //    var x1 = OMS.ProductBOMRow.getLookup().items.filter(x => x.ProductId.toString() == prdid);
                   /* var x2 = []; PurchaseItemsBOMRow.getLookup().items;


                    var e2 = x2.length;
                    //var c1: Array<PurchaseItemsBOMRow>;
                    for (var b = 0; b < e2; b++) {
                        x2.pop();
                    }

                    var e1 = x1.length;
                    for (var b = 0; b < x1.length; b++) {

                        var x3: PurchaseItemsBOMRow = {
                            Attribute: x1[b].Attribute,
                            BomAmount: x1[b].Amount,
                            BOMAttributeId: x1[b].BOMAttributeId,
                            BomRate: x1[b].Rate,
                            CalcOn: x1[b].CalculateOn,
                            CertificateNo: x1[b].CertificateNo,
                            Pieces: x1[b].Pieces,
                            Weight: x1[b].Weight,
                            ProductCode: x1[b].ProductCode,
                            ProductId: x1[b].ProductId,
                            BOMProductId: x1[b].BOMProductId,
                        }
                        x2.push(x3);

                    }
                    x1.forEach(function (value) {
                        x3.Attribute = value.Attribute;
                        x3.BomAmount = value.Amount;
                        x3.BomAtbId = value.AttributeId;
                        x3.BomRate = value.Rate;
                        x3.CalcOn = value.CalculateOn.toString();
                        x3.CertificateNo = value.CertificateNo;
                        x3.Pieces = value.Pieces;
                        x3.Weight = value.Weight;
                        x3.ProductCode = value.ProductCode;
                        x2.push(x3);
                    });*/

                    //    var v= new OMS.ProductMasterRow();
                    //    v.PrdId = value.ProductId;
                    //    c1.push(v);
                    //});

             //       this.form.BOMDetails.value = x2;
                    //    this.form.BOMDetails.setItems(x1);

                    //  this.form.BOMDetails.render;
                }


            });

            // **** On Wastage % Change Event **** 
            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });
            this.form.HasBom.changeSelect2(e => {
                if (this.form.HasBom.value) {
                    q.hideField(this.form.KaratId)
                    q.hideField(this.form.Purity)
                }
                else {
                    q.showAndSetRequiredField(this.form.KaratId)
                    q.showAndSetRequiredField(this.form.Purity)
                    q.showAndSetRequiredField(this.form.MetalId)
                }

            })
            
            this.form.KaratId.changeSelect2(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false }); 
                var std = purity.StdPurity;
                this.form.Purity.value = std;
            });
            this.form.Purity.change(e => {
                var current = this.form.Purity.value;
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                var min = purity.MinPurity;
                var max = purity.MaxPurity;
                var std = purity.StdPurity;
                if (current < min || current > max) {
                    Q.alert("Enter Purity between  " + min.toString() + "  to  " + max.toString());
                    this.form.Purity.value = std;
                }
            });

            // **** On Product Code Change Event **** 
            //Validate Product Code for Duplication 
            this.form.ProductCode.changeSelect2(e => {
                try {
                    let id;
                    OMS.ProductMasterService.CustomList({ ProductCode: this.form.ProductCode.value.toUpperCase() },
                        response => {
                            id = response.Entities[0];
                        }, { async: false });
                    
                    if (id.ProductId != null || id.ProductId > 0) {
                        Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                        this.form.ProductCode.value = "";
                        this.form.ProductCode.element.focus();
                        return;

                    }
                }
                catch (undefined) {

                }
            });

        }
        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.entityId != undefined) {
                if (!this.form.HasBom.value) {
                    this.HasBom = false;
                   // q.hideEditorCategory(this.form.BOMDetails);
                   // q.hideField(this.form.BOMDetails);
                    this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                }
            }
        } 
    }
}